function ProfileIcon() {
  return (
    <svg
      className="w-full"
      width="262"
      height="305"
      viewBox="0 0 262 305"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M246.818 2.03516H14.2537C11.5346 2.03516 9.02229 2.03679 6.98961 2.03875C4.2318 2.04141 1.99991 4.27824 1.99991 7.03605L1.99988 297.035C1.99988 299.797 4.23846 302.035 6.99988 302.035H254.072C256.833 302.035 259.072 299.797 259.072 297.035V7.03591C259.072 4.27748 256.839 2.04035 254.08 2.03814C252.048 2.03652 249.536 2.03516 246.818 2.03516Z"
        fill="#696F7A"
      />
      <path
        d="M254.072 2.04563L14.2537 2.03972C11.5405 2.03972 9.03319 2.03899 7.00283 2.03811C4.23978 2.03691 1.99988 4.27628 1.99988 7.03934L2.00011 297.035C2.00011 299.797 4.23869 302.035 7.00011 302.035H254.072C256.833 302.035 259.072 299.797 259.072 297.035V7.04563C259.072 4.28425 256.833 2.04569 254.072 2.04563Z"
        stroke="#696F7A"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="6.4845"
        y="5.83594"
        width="46.2445"
        height="292.398"
        rx="1"
        fill="#C4C4C4"
      />
      <circle
        cx="150.098"
        cy="71.475"
        r="21.1547"
        stroke="white"
        strokeWidth="5"
      />
      <path
        d="M106.038 137.633V137.633C106.038 119.596 120.66 104.975 138.696 104.975H150.099H161.501C179.537 104.975 194.159 119.596 194.159 137.633V137.633"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <line
        x1="88.0591"
        y1="190.322"
        x2="218.54"
        y2="190.322"
        stroke="#33495E"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <line
        x1="88.0591"
        y1="222.035"
        x2="218.54"
        y2="222.035"
        stroke="#33495E"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <line
        x1="88.0591"
        y1="253.748"
        x2="191.033"
        y2="253.748"
        stroke="#33495E"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default ProfileIcon
